import { render } from "./TariffData.vue?vue&type=template&id=e5586c9e&scoped=true"
import script from "./TariffData.vue?vue&type=script&lang=js"
export * from "./TariffData.vue?vue&type=script&lang=js"

import "./TariffData.vue?vue&type=style&index=0&id=e5586c9e&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5586c9e"]])

export default __exports__